import { actions, initialState } from "./state";

export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actions.CHANGE_BUNDLE:
			return {
				...state,
				bundle: action.payload,
			};
		case actions.CHANGE_KUNJUNGAN:
			return {
				...state,
				kunjungan: action.payload,
			};
		case actions.CHANGE_DETAIL_HEADER:
			return {
				...state,
				detail: action.payload,
			};
		case actions.CHANGE_LOADING:
			return {
				...state,
				loading: action.payload,
			};

		default:
			return state;
	}
};
